import { useState } from "react";
import "./register-screen.scss";
import Button from "src/libraries/components/button/Button";
import LoginInput from "src/libraries/components/form-login/form-login";
import { useForm, FormProvider } from "react-hook-form";
import dayjs from "dayjs";
import { fetch, post } from "src/common/networks/api-helper";
import { URL_PATHS } from "src/common/networks/url-paths";
import localStorageHelpers, {
  StorageKey,
} from "src/common/storage/local-storage-helpers";
import { useHistory } from "react-router-dom";
import ToastifyAdapter from "src/libraries/components/toastify/toastify.adapter";
export const RegisterScreen = () => {
  const { errorFromAPI, success } = ToastifyAdapter();
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState(true);
  const history = useHistory();
  const methods = useForm<Record<string, any>>({
    mode: "onChange",
    criteriaMode: "all",
  });
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const onSubmit = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: Record<string, any>
  ) => {
    event.preventDefault();
    console.log(data.dob);
    const formattedDate = dayjs(data.dob).format("YYYY-MM-DD");
    const body = {
      username: data.username,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
      dob: formattedDate,
      email: data.email,
      phoneNumber: data.phoneNumber,
    };
    //console.log(formattedDate);
    console.log(body);

    handleRegister(body);
  };
  const handleRegister = (data: Record<string, any>) => {
    console.log(data);
    post(URL_PATHS.REGISTER, data, false, true)
      .then((res) => {
        console.log(res);
        if (res && res.data.code === 1000) {
          success("Đăng ký thành công");
          history.push("/login");
        }
      })
      .catch((e) => {
        console.log("ERROR REGISTER", e);
        errorFromAPI(e.response.data.code, e.response.data.message);
      });
  };

  return (
    <div className="register-background">
      <div className="register-container">
        <div className="login-logo">
          <img
            src={require("../../assets/payment-logo.jpg")}
            alt="hyperlogy-logo"
          />
        </div>
        <div className="sign-in-form">
          <div className="form-container">
            <div className="form-top">
              <div className="form-title">
                <img
                  src={require("../../assets/hyper.jpg")}
                  alt="hyperlogy-logo"
                />
              </div>
            </div>
            <div className="form-bot">
              <FormProvider {...methods}>
                <form
                //onSubmit={methods.handleSubmit(() => onSubmit)}
                >
                  <div className="form-input">
                    <div className="group-input">
                      <LoginInput
                        name="username"
                        type=""
                        label="Tên tài khoản"
                        placeholder="Tên tài khoản"
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                        }}
                      />

                      <LoginInput
                        name="password"
                        type="password"
                        label="Password"
                        placeholder="Mật khẩu"
                        isPassword={true}
                        disable={false}
                        visiblePassword={isPasswordVisible}
                        setVisiblePassword={setIsPasswordVisible}
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                          minLength: {
                            value: 6,
                            message: "Mật khẩu dài ít nhất 6 ký tự",
                          },
                        }}
                      />
                    </div>
                    <div className="group-input">
                      <LoginInput
                        name="firstName"
                        type=""
                        label="Họ"
                        placeholder="Họ"
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                        }}
                      />

                      <LoginInput
                        name="lastName"
                        type=""
                        label="Tên"
                        placeholder="Tên"
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                        }}
                      />
                    </div>
                    <div className="group-input">
                      <LoginInput
                        name="email"
                        type="email"
                        label="Email"
                        placeholder="Email"
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                        }}
                      />

                      <LoginInput
                        name="phoneNumber"
                        type=""
                        label="Số điện thoại"
                        placeholder="Số điện thoại"
                        style={{ width: "100%", height: 40, fontSize: 18 }}
                        rules={{
                          required: "Bắt buộc",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "10 chữ số",
                          },
                        }}
                      />
                    </div>
                    <LoginInput
                      name="dob"
                      type="date"
                      label="Ngày sinh"
                      placeholder="Ngày sinh"
                      style={{ width: "100%", height: 40, fontSize: 18 }}
                      rules={{
                        required: "Bắt buộc",
                        // pattern: {
                        //   value: /^\S+@\S+\.\S+$/,
                        //   message: "Email không đúng định dạng",
                        // },
                      }}
                    />
                  </div>

                  {/* <div className="checkbox">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <div>
                      Bằng cách đăng kí, tôi chấp nhận Chính sách bảo mật và
                      Thỏa thuận sử dụng.
                    </div>
                  </div> */}
                  <div className="form-submit-btn">
                    <Button
                      children={
                        <div style={{ fontSize: 20 }}>Tạo tài khoản</div>
                      }
                      background="linear-gradient(180deg, #4697fe, #08f)"
                      textColor="white"
                      borderColor="white"
                      height={"50px"}
                      width={"100%"}
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
                        onSubmit(
                          event,
                          methods.getValues() as Record<string, any>
                        )
                      }
                      isDisabled={!isChecked}
                      marginRight="0"
                      className="submit-button"
                      marginLeft="0"
                    />
                  </div>
                </form>
              </FormProvider>
              <div className="form-to-login">
                Đã có tài khoản ?{" "}
                <span onClick={() => history.push("/login")}>Đăng nhập</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
